import React, {useEffect} from 'react'
import { createPortal } from 'react-dom'
import styles from '../style/components/modal.module.css'

const Modal = ({ children, onClose }) => {


    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") {
                onClose()
            }
        }
        document.addEventListener("keydown", handleEsc)
        return () => document.removeEventListener("keydown", handleEsc)
    }, [onClose])

	 const handleStopProp = (e) => {
        e.stopPropagation()
     }
	return createPortal(
		<div className={styles.modalContainer} onClick={onClose}>
			<div className={styles.modalContent} onClick={handleStopProp}>
				<button className={styles.modalBtnClose} onClick={onClose}>
					<img src='/exit.svg' />
				</button>
				{children}
			</div>
		</div>, document.getElementById("portal-root")
	)
}

export default Modal
